<template>
  <ul
    class="kf-list"
    :class="classes"
  >
    <li
      v-for="item in items"
      :key="item.label"
      class="kf-list-item"
    >
      <a
        v-if="item.href"
        :href="item.href"
        :target="item.target ? item.target : false"
        :rel="item.target ? 'noopener noreferrer' : false"
        class="kf-list-link"
      >
        {{ item.label }}
      </a>
      <template v-else>
        {{ item.label }}
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'KfList',
  props: {
    items: {
      type: Array,
      default: null,
    },
    isBig: {
      type: Boolean,
      default: false,
    },
    isBlack: {
      type: Boolean,
      default: false,
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'is-black': this.isBlack,
        'is-big': this.isBig,
        'is-white': this.isWhite,
      };
    },
  },
};
</script>

<style lang="postcss" scoped>
.kf-list {
  @apply list-none;

  &-item {
    @apply mb-2;
    font-size: 15px;

    &:last-of-type {
      @apply mb-0;
    }
  }

  &.is-black {
    .kf-list-item,
    .kf-list-link {
      @apply text-black;
    }
  }

  &.is-white {
    .kf-list-item,
    .kf-list-link {
      @apply text-white;
    }
  }
}

.kf-list-link {
  @apply text-primary-bravo no-underline;

  &:hover {
    @apply underline;
  }
}

.is-big {
  .kf-list-item {
    @apply mb-4 relative pl-4 text-xl md:mb-8 md:pl-6 md:text-2xl;

    &::before {
      content: '';
      @apply block absolute left-0;
      top: 5px;
      width: 8px;
      height: 100%;

      background-image: url('~@/assets/svg/chevron-right-secondary.svg?inline');
      background-repeat: no-repeat;
      background-size: contain;

      .theme-secondary & {
        background-image: url('~@/assets/svg/theme-secondary/ts-chevron-right-secondary.svg?inline');
      }

      @screen md {
        width: 10px;
        top: 9px;
      }
    }
  }

  .kf-list-link {
    @apply no-underline font-bold text-xl md:text-2xl;
  }
}
</style>
